import { Link } from "react-router-dom";

export default function FounderNarrative() {
  return (
    <div className="col-span-12 md:col-span-7 lg:col-span-6 lg:col-start-7 md:pt-8">
      <div className="eyebrow-light mb-8">From the Founder</div>
      <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] tracking-tight">
        Yashank Kalia
      </h2>
      <div className="mt-4 text-[11px] tracking-widest3 uppercase text-ivory/55 font-medium">
        Founder & Managing Director
      </div>

      <div className="mt-12 space-y-6 text-lg leading-[1.85] text-ivory/85 font-light max-w-2xl">
        <p>
          Indiora Journeys began with a quiet conviction — that the
          finest travel through South Asia should be measured not in
          miles, but in moments. As Founder & Managing Director, I lead
          a small team of curators who design every itinerary the
          way one might compose a piece of music: privately, attentively,
          and never twice the same.
        </p>
        <p>
          I grew up in the rhythm of these lands — between Himalayan
          monasteries, the courtyards of Rajasthan, and the still ghats
          of Pushkar where I am photographed here. Indiora is my answer
          to the question I kept asking the industry: <em className="italic text-goldleaf">why does luxury travel
          feel so hurried?</em>
        </p>
        <p>
          Should you choose to travel with us, you will be in the hands
          of people who care for South Asia as their own home — because
          it is.
        </p>
      </div>

      <div className="mt-12 flex items-center gap-6">
        <div className="font-serif text-3xl italic text-goldleaf">— Y. Kalia</div>
        <div className="hidden sm:block w-16 h-px bg-ivory/30" />
        <Link
          to="/contact"
          className="text-[11px] tracking-widest2 uppercase font-semibold text-ivory border-b border-goldleaf pb-1 hover:text-goldleaf transition-colors"
        >
          Write to the Founder
        </Link>
      </div>
    </div>
  );
}
